export default "__VITE_ASSET__DCRTflMH__"